// extracted by mini-css-extract-plugin
export default {"modalViewContainer":"modal_modalViewContainer__ni8Dl","modalContainer":"modal_modalContainer__GYR3V","puzzle":"modal_puzzle__fcTBx","puzzleWord":"modal_puzzleWord__4nNTD"};